export default __webpack_public_path__ + "static/media/offer_banner-1.e8af4677.jpg";